module.exports = __webpack_public_path__ + "img/homepage-schnelle.4949f08.svg";